/* eslint-disable max-lines */
import React from 'react';

import {Feature, FeatureWithAnalytics} from 'components/feature';

import {PAYMENTS} from '../../constants/paymentStep';
import {PaymentAmazonConnected as PaymentAmazonV2Connected} from '../paymentAmazonV2/paymentAmazonV2';
import {PaymentApplePayWrapper} from '../paymentApplePay/paymentApplePayWrapper';
import {PaymentApplePayPrimerConnected} from '../paymentApplePayPrimer/paymentApplePayPrimer';
import {PaymentCreditCardWrapperConnected} from '../paymentCreditCardWrapper/paymentCreditCardWrapper';
import {PaymentGooglePayConnected} from '../paymentGooglePay/paymentGooglePay';
import {PaymentGooglePayPrimerConnected} from '../paymentGooglePayPrimer/paymentGooglePayPrimer';
import {PaymentKlarnaConnected} from '../paymentKlarna/paymentKlarna';
import {PaymentKlarnaPrimerConnected} from '../paymentKlarnaPrimer/paymentKlarnaPrimer';
import {PaymentPaypalPrimerConnected} from '../paymentPaypalPrimer/paymentPaypalPrimer';
import {PaymentPaypalV3Connected} from '../paymentPayPalV3/paymentPayPalV3';
import {PrimerWrapperConnected} from '../paymentPrimerCreditCard/primerWrapper';
import {PaymentVenmoPrimerConnected} from '../paymentPrimerVenmo/paymentPrimerVenmo';
import {PaymentReculryConnected} from '../paymentRecurly/paymentRecurly';
import {PaymentRecurlyPayPalConnected} from '../paymentRecurlyPayPal/paymentRecurlyPayPal';
import {PaymentStripeConnected} from '../paymentStripe/paymentStripe';
import {PaymentVenmoWrapperConnected} from '../paymentVenmo/paymentVenmoWrapper';

export const PAYMENTS_COMPONENTS: {[key in PAYMENTS]?: React.ReactElement} = {
    [PAYMENTS.METHOD_AMAZON_V2]: <PaymentAmazonV2Connected key={PAYMENTS.METHOD_AMAZON_V2} />,
    [PAYMENTS.METHOD_APPLE_PAY]: (
        <Feature
            fallback={<PaymentApplePayWrapper key={PAYMENTS.METHOD_APPLE_PAY} />}
            flag="dCheckoutPrimerApplePay"
            key={PAYMENTS.METHOD_APPLE_PAY}
            platform="desktop"
        />
    ),
    [PAYMENTS.METHOD_CREDIT_CARD]: (
        <Feature
            fallback={<PaymentCreditCardWrapperConnected />}
            flag="checkoutPrimerCreditCard"
            key={PAYMENTS.METHOD_CREDIT_CARD}
            platform="desktop"
        />
    ),
    [PAYMENTS.METHOD_DEFAULT]: <React.Fragment key={PAYMENTS.METHOD_DEFAULT} />,
    [PAYMENTS.METHOD_GOOGLE_PAY]: (
        <Feature
            fallback={<PaymentGooglePayConnected />}
            flag="checkoutPrimerGooglePay"
            key={PAYMENTS.METHOD_GOOGLE_PAY}
            platform="desktop"
        />
    ),
    [PAYMENTS.METHOD_KLARNA]: (
        <Feature
            fallback={<PaymentKlarnaConnected key={PAYMENTS.METHOD_KLARNA} />}
            flag="primerKlarna"
            key={PAYMENTS.METHOD_KLARNA}
            platform="desktop"
        />
    ),

    [PAYMENTS.METHOD_PAYPAL_V3]: (
        <Feature
            fallback={<PaymentPaypalV3Connected />}
            flag="checkoutPrimerPayPal"
            key={PAYMENTS.METHOD_PAYPAL_V3}
            platform="desktop"
        />
    ),
    [PAYMENTS.METHOD_PRIMER]: (
        <FeatureWithAnalytics
            flag="checkoutPrimerCreditCard"
            isInteraction={false}
            key={PAYMENTS.METHOD_PRIMER}
            platform="desktop"
        >
            <PrimerWrapperConnected />
        </FeatureWithAnalytics>
    ),
    [PAYMENTS.METHOD_PRIMER_APPLE_PAY]: (
        <FeatureWithAnalytics
            flag="dCheckoutPrimerApplePay"
            isInteraction={false}
            key={PAYMENTS.METHOD_PRIMER_APPLE_PAY}
            platform="desktop"
        >
            <PaymentApplePayPrimerConnected />
        </FeatureWithAnalytics>
    ),
    [PAYMENTS.METHOD_PRIMER_GOOGLE_PAY]: (
        <FeatureWithAnalytics
            flag="checkoutPrimerGooglePay"
            isInteraction={false}
            key={PAYMENTS.METHOD_PRIMER_GOOGLE_PAY}
            platform="desktop"
        >
            <PaymentGooglePayPrimerConnected />
        </FeatureWithAnalytics>
    ),
    [PAYMENTS.METHOD_PRIMER_KLARNA]: (
        <FeatureWithAnalytics
            flag="primerKlarna"
            isInteraction={false}
            key={PAYMENTS.METHOD_PRIMER_KLARNA}
            platform="desktop"
        >
            <PaymentKlarnaPrimerConnected />
        </FeatureWithAnalytics>
    ),
    [PAYMENTS.METHOD_PRIMER_PAYPAL]: (
        <FeatureWithAnalytics
            flag="checkoutPrimerPayPal"
            isInteraction={false}
            key={PAYMENTS.METHOD_PRIMER_PAYPAL}
            platform="desktop"
        >
            <PaymentPaypalPrimerConnected />
        </FeatureWithAnalytics>
    ),
    [PAYMENTS.METHOD_PRIMER_VENMO]: (
        <FeatureWithAnalytics
            flag="checkoutPrimerVenmo"
            isInteraction={false}
            key={PAYMENTS.METHOD_PRIMER_VENMO}
            platform="desktop"
        >
            <PaymentVenmoPrimerConnected />
        </FeatureWithAnalytics>
    ),
    [PAYMENTS.METHOD_RECURLY]: <PaymentReculryConnected key={PAYMENTS.METHOD_RECURLY} />,
    [PAYMENTS.METHOD_RECURLY_PAYPAL]: (
        <PaymentRecurlyPayPalConnected key={PAYMENTS.METHOD_RECURLY_PAYPAL} />
    ),
    [PAYMENTS.METHOD_STRIPE]: <PaymentStripeConnected key={PAYMENTS.METHOD_STRIPE} />,
    [PAYMENTS.METHOD_VENMO]: (
        <Feature
            fallback={<PaymentVenmoWrapperConnected key={PAYMENTS.METHOD_VENMO} />}
            flag="checkoutPrimerVenmo"
            key={PAYMENTS.METHOD_VENMO}
            platform="desktop"
        />
    ),
};
